"use strict";
/**
 * 大数据统计- 首屏加载时间统计
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * 统计加载时间，发送大数据统计
 */
function loadTimeSata() {
    if (window.performance != undefined && window.performance.timing != undefined && JSON) {
        var timing_1 = window.performance.timing;
        var starttime = timing_1.navigationStart;
        var endtime = (new Date()).getTime();
        var timespan_1 = endtime - starttime;
        var thiscd_1 = setInterval(function () {
            if (timing_1.domComplete > 0) {
                clearInterval(thiscd_1);
                //指标部分
                var deinfo = {
                    redirect: timing_1.redirectEnd - timing_1.redirectStart,
                    dns: timing_1.domainLookupEnd - timing_1.domainLookupStart,
                    ttfb: timing_1.responseStart - timing_1.navigationStart,
                    request: timing_1.responseEnd - timing_1.requestStart,
                    net: timing_1.responseEnd - timing_1.navigationStart,
                    dom: timing_1.domComplete - timing_1.responseEnd //dom解析时间
                };
                if (timespan_1 > 0) {
                    send(timespan_1, JSON.stringify(deinfo));
                }
            }
        }, 1000);
    }
}
/**
 * 是否已经发送过
 */
var issend = false;
/**
 * 发送大数据统计
 * @param time
 */
function send(time, deinfo) {
    if (issend) {
        return false;
    }
    // console.info(111)
    if (window.sendFirstScreenLog != undefined) {
        // console.info(deinfo)
        window.sendFirstScreenLog(time, deinfo);
        issend = true;
    }
    else {
        setTimeout(function () {
            if (window.sendFirstScreenLog != undefined) {
                // console.info(deinfo)
                window.sendFirstScreenLog(time, deinfo);
                issend = true;
            }
        }, 3000);
    }
}
exports.default = loadTimeSata;
